import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { request } from '@/api/http';
import { useMe } from '@/context/MeContext';

export default function AcceptTerms() {
  const navigate = useNavigate();
  const { me, loading, refresh } = useMe();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (loading) return;
    if (!me?.termsAcceptanceRequired) {
      navigate('/', { replace: true });
    }
  }, [loading, me?.termsAcceptanceRequired, navigate]);

  async function accept() {
    setSubmitting(true);
    setError(null);
    try {
      await request<{ ok: boolean }>('/legal/accept/terms', { method: 'POST' });
      await refresh();
      navigate('/', { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to accept Terms');
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <span>Loading…</span>
      </div>
    );
  }

  return (
    <div className="panel" style={{ maxWidth: 780, margin: '0 auto' }}>
      <h1>Review and accept the Terms</h1>
      <p>
        Before you can access Scoutly, you must accept the current Terms and Conditions.
      </p>
      <p className="muted">
        Current Terms version: <strong>{me?.currentTermsVersion ?? '—'}</strong>
      </p>
      {error ? <div className="alert alert-error">{error}</div> : null}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <a className="btn btn-ghost" href="/terms" target="_blank" rel="noreferrer">
          Open Terms
        </a>
        <button type="button" className="btn btn-primary" disabled={submitting} onClick={() => void accept()}>
          {submitting ? 'Saving…' : 'I agree and continue'}
        </button>
      </div>
    </div>
  );
}
